<template>
  <div class="app">
    <div v-if="loading">
      <BlockUI :message="blockuimsg"></BlockUI>
    </div>
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/brand/logo.png" width="120" height="40" alt="Kiwa Logo">
        <img class="navbar-brand-minimized" src="img/brand/nunsys.png" width="30" height="30" alt="Nunsys Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <template>
        <select @change="actualizarPaneldeNavegacion()" class="text-center" v-model="$i18n.locale">
          <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
        </select>
      </template>
      <b-navbar-nav class="ml-auto">
        <b-nav-item class="d-md-down-none">
          <DefaultHeaderDropdownNotif />
        </b-nav-item>
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="https://www.kiwa.com/es/es/">Kiwa</a>
        <span class="ml-1">&copy; 2019</span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultHeaderDropdownNotif from './DefaultHeaderDropdownNotif'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultHeaderDropdownNotif,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data() {
    return {
      nav: this.setMenu(),
      langs: ['es', 'en', 'fr']
    }
  },
  computed: {
    name() {
      return this.$route.name
    },
    list() {
      return this.$route.matched.filter((route) => route.name || route.meta.label)
    }
  },
  methods: {
    setMenu() {
      if (localStorage.getItem('lang') != null) {
        this.$i18n.locale = localStorage.getItem('lang');
      }
      var menu = {
        items: []
      }
      var visuales = {
        items: [
          {
            title: true,
            name: 'Formularios',
            class: '',
            wrapper: {
              element: '',
              attributes: {}
            }
          },
          {
            name: this.$t('CommercialView'),
            url: '/grillacomercial',
            visual: 'COM01',
            icon: 'fa fa-line-chart',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('ScheduleView'),
            url: '/grillaplanificacion',
            visual: 'PLA01',
            icon: 'fa fa-calendar',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('InspectionView'),
            url: '/grillainspeccion',
            visual: 'INS01',
            icon: 'fa fa-search',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('BackOfficeView'),
            url: '/grillabackoffice',
            icon: 'fa fa-inbox',
            visual: 'BOF01',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('OperationsView'),
            url: '/grillaoperaciones',
            icon: 'fa fa-briefcase',
            visual: 'OPE01',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('ManagersView'),
            url: '/grillagestores',
            icon: 'fa fa-user-circle-o',
            visual: 'GES01',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('ReportsView'),
            url: '/grillareportes',
            icon: 'fa fa-print',
            visual: 'REP01',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('AdminView'),
            url: '/grillaadministracion',
            icon: 'fa fa-book',
            visual: 'ADM01',
            badge: {
              variant: '',
              text: ''
            }
          }
        ]
      };
      var globalgap = {
        items: [
          {
            title: true,
            name: this.$t('GlobalGapTitle'),
            class: '',
            wrapper: {
              element: '',
              attributes: {}
            }
          },
          {
            name: this.$t('NewAudit'),
            url: '/globalgap/newaudit',
            icon: 'fa fa-superpowers',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('Templates'),
            url: '/globalgap/templates',
            icon: 'fa fa-ravelry',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('ClientsGlobalGap'),
            url: '/clientsGlobalGap',
            icon: 'icon-user',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('ProtocolsGlobalGap'),
            url: '/protocolsGlobalGap',
            icon: 'icon-vector',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('RmsValidationService'),
            url: '/rmsValidationService',
            icon: 'icon-list',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('SiteValidationService'),
            url: '/siteValidationService',
            icon: 'icon-list',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('ProducerValidationService'),
            url: '/producerValidationService',
            icon: 'icon-list',
            badge: {
              variant: '',
              text: ''
            }
          }                              
        ]
      };
      var seguridad = {
        items: [
          {
            title: true,
            name: this.$t('Security'),
            class: '',
            wrapper: {
              element: '',
              attributes: {}
            }
          },
          {
            name: this.$t('Users'),
            url: '/users',
            icon: 'icon-user',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('Roles'),
            url: '/roles',
            icon: 'icon-user-follow',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('AuditorsProtocols'),
            url: '/AuditorProtocol',
            icon: 'icon-people',
            badge: {
              variant: '',
              text: ''
            }
          },
        ]
      };
      var administracion = {
        items: [
          {
            title: true,
            name: this.$t('Administration'),
            class: '',
            wrapper: {
              element: '',
              attributes: {}
            }
          },
          {
            name: this.$t('Countries'),
            url: '/Countries',
            icon: 'icon-globe',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('Files'),
            url: '/Files',
            icon: 'icon-folder',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('FileTypes'),
            url: '/FileTypes',
            icon: 'icon-folder-alt',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('StandardsGroup'),
            url: '/GroupStandards',
            icon: 'icon-list',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('Protocol'),
            url: '/Protocols',
            icon: 'icon-vector',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('Clients'),
            url: '/Clients',
            icon: 'icon-user',
            badge: {
              variant: '',
              text: ''
            }
          },
          {
            name: this.$t('Colaborators'),
            url: '/Collaborators',
            icon: 'icon-user',
            badge: {
              variant: '',
              text: ''
            }
          },
        ]
      };


      // Array auxiliar para filtrar las visuales
      const visualesAux = visuales;

      // Tipo de usuario del usuario logueado
      const tipoUsuario = this.$auth.user().tipo_usuario;

      // Tiene Acceso al ABM Clientes
      const accesoABMClientes = this.$auth.user().abm_clientes;

      // Tiene Acceso a GlobalGAP
      const accesoGlobalGAP = this.$auth.user().globalgap;

      // Si se perdió la sesión, cierro sessión
      if (this.$auth.user().tipo_usuario === undefined) {
        this.actionLogout();
        return false;
      }

      // Obtengo el código interno de los accesos
      const rolAccesos = this.getRolesAccesos(this.$auth.user().rol_accesos, tipoUsuario);

      // Filtro los visuales por el acceso correcto
      const visualesFilter = visualesAux.items.filter(function (v) {
        return rolAccesos.includes(v.visual);
      });

      // Activo al menú las visuales a los que el usuario tiene permisos
      Array.prototype.push.apply(menu.items, visualesFilter);

      // Chequeo a que opciones de menú puede ingresar en base al tipo_usuario/rol

      // Agrego el ABM Clientes siempre y cuando el rol lo permita
      var itemsUsuarioComun = [];

      if (accesoABMClientes) {
        itemsUsuarioComun.push(administracion.items[0]);
        itemsUsuarioComun.push(administracion.items[6]);
      }

      if (accesoGlobalGAP) {
        Array.prototype.push.apply(menu.items, globalgap.items);
      }

      switch (tipoUsuario) {
        case 'S':
          Array.prototype.push.apply(menu.items, seguridad.items);
          Array.prototype.push.apply(menu.items, administracion.items);
          break;
        case 'A':
          Array.prototype.push.apply(menu.items, administracion.items);
          break;
        case 'U':
          Array.prototype.push.apply(menu.items, itemsUsuarioComun);
          break;
      }

      // Retorno ya el menú armado
      return menu.items;
    },

    actualizarPaneldeNavegacion() {
      localStorage.setItem('lang', this.$i18n.locale);
      this.nav = this.setMenu();
    }
  }
}
</script>
